import { useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomIcon from "../../UI/CustomIcon";
import './SidebarMenu.scss';


const SidebarItem = ({ item, collapsed, location }) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = item.children && item.children.length > 0;
  const isActive = hasChildren 
    ? item.children.some(child => location.pathname === child.path)
    : location.pathname === item.path;

  const handleClick = (e) => {
    if (hasChildren) {
      e.preventDefault();
      setExpanded(!expanded);
    }
  };

  const iconName = item.icon;

  return (
    <>
      <Nav.Item>
        <Nav.Link
          as={hasChildren ? 'div' : Link}
          to={hasChildren ? '#' : item.path}
          onClick={handleClick}
          className={`sidebar-item ${isActive ? 'active' : ''} ${collapsed ? 'collapsed' : ''}`}
          title={collapsed ? item.title : ''}
        >
          <div className="sidebar-item-content">
            <CustomIcon name={iconName} size={24} className="sidebar-icon" />
            {!collapsed && (
              <>
                <span className="sidebar-text">{item.title}</span>
                {hasChildren && (
                  <CustomIcon 
                    name="right" 
                    size={16} 
                    className={`chevron ${expanded ? 'rotated' : ''}`}
                  />
                )}
              </>
            )}
          </div>
        </Nav.Link>
      </Nav.Item>

      {/* Submenu */}
      {hasChildren && !collapsed && expanded && (
        <div className="sidebar-submenu">
          {item.children.map((child, index) => {
            const hasOnClick = typeof child.onClick === 'function';
            
            return (
              <Nav.Item key={index}>
                {hasOnClick ? (
                  <Nav.Link
                    as="div"
                    onClick={(e) => {
                      e.preventDefault();
                      child.onClick();
                    }}
                    className={`sidebar-subitem ${location.pathname === child.path ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="sidebar-text">{child.title}</span>
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    to={child.path}
                    className={`sidebar-subitem ${location.pathname === child.path ? 'active' : ''}`}
                  >
                    <span className="sidebar-text">{child.title}</span>
                  </Nav.Link>
                )}
              </Nav.Item>
            );
          })}
        </div>
      )}
    </>
  );
};

export default SidebarItem;
